export default __webpack_public_path__ + "static/generic-image-5422fb486e9d439fd0ea60d9037368da.png";